import { Route, Routes } from "react-router-dom";
import { ChooserPage } from "../pages/chooser.page";
import { DatenschutzPage } from "../pages/datenschutz.page";
import { ImpressumPage } from "../pages/impressum.page";

export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<ChooserPage />} />
    <Route path="/impressum" element={<ImpressumPage />} />
    <Route path="/datenschutz" element={<DatenschutzPage />} />
    {/* Not a 404: bookmarks of the classic portal map onto nothing in the three applications. */}
    <Route path="*" element={<ChooserPage showMovedNotice />} />
  </Routes>
);
